import { PaymentMethod } from "modules/ClientAccount/utils"

export interface FormPageStateInterface {
    name: string
    phone: string
    email: string
    showErrors: boolean
    showEmailError: boolean
    nameError: string
    emailError: string
    phoneError: string
    offerAccepted: boolean
    personalDataAccepted: boolean
    eulaAccepted: boolean
    informedAgreement: boolean
    payByCard: PaymentMethod | null
}

export interface FormPageActionInterface {
    type: ActionNames | string
    payload: boolean | string | undefined | null | PaymentMethod
}

export const INITIAL_STATE: FormPageStateInterface = {
    name: "",
    phone: "",
    email: "",
    showErrors: false,
    showEmailError: false,
    nameError: "",
    emailError: "",
    phoneError: "",
    offerAccepted: true,
    personalDataAccepted: true,
    eulaAccepted: true,
    informedAgreement: true,
    payByCard: null,
}

enum ActionNames {
    SET_SHOW_ERRORS = "SET_SHOW_ERRORS",
    SET_SHOW_EMAIL_ERRORS = "SET_SHOW_EMAIL_ERRORS",
    SET_NAME_ERROR = "SET_NAME_ERROR",
    SET_EMAIL_ERROR = "SET_EMAIL_ERROR",
    SET_PHONE_ERROR = "SET_PHONE_ERROR",
    SET_OFFER_ACCEPTED = "SET_OFFER_ACCEPTED",
    SET_PERSONAL_DATA_ACCEPTED = "SET_PERSONAL_DATA_ACCEPTED",
    SET_EULA_ACCEPTED = "SET_EULA_ACCEPTED",
    SET_INFORMED_AGREEMENT = "SET_INFORMED_AGREEMENT",
    SET_PAY_BY_CARD = "SET_PAY_BY_CARD",
}

export const setName = (data: string) => ({
    type: "SET_NAME",
    payload: data,
})

export const setPhone = (data: string) => ({
    type: "SET_PHONE",
    payload: data,
})

export const setEmail = (data: string) => ({
    type: "SET_EMAIL",
    payload: data,
})

export const setShowErrors = (data: boolean) => ({
    type: "SET_SHOW_ERRORS",
    payload: data,
})

export const setShowEmailError = (data: boolean) => ({
    type: "SET_SHOW_EMAIL_ERRORS",
    payload: data,
})

export const setNameError = (data: string) => ({
    type: "SET_NAME_ERROR",
    payload: data,
})

export const setEmailError = (data: string | undefined) => ({
    type: "SET_EMAIL_ERROR",
    payload: data,
})

export const setPhoneError = (data: string | undefined) => ({
    type: "SET_PHONE_ERROR",
    payload: data,
})

export const setOfferAccepted = (data: boolean) => ({
    type: "SET_OFFER_ACCEPTED",
    payload: data,
})

export const setPersonalDataAccepted = (data: boolean) => ({
    type: "SET_PERSONAL_DATA_ACCEPTED",
    payload: data,
})

export const setEulaAccepted = (data: boolean) => ({
    type: "SET_EULA_ACCEPTED",
    payload: data,
})

export const setInformedAgreement = (data: boolean) => ({
    type: "SET_INFORMED_AGREEMENT",
    payload: data,
})

export const setPayByCard = (data: PaymentMethod | null) => ({
    type: "SET_PAY_BY_CARD",
    payload: data,
})

export const reducer = (
    state: FormPageStateInterface,
    action: FormPageActionInterface
): FormPageStateInterface => {
    switch (action.type) {
        case "SET_NAME":
            return {
                ...state,
                name: action.payload as string,
            }
        case "SET_PHONE":
            return {
                ...state,
                phone: action.payload as string,
            }
        case "SET_EMAIL":
            return {
                ...state,
                email: action.payload as string,
            }
        case "SET_SHOW_ERRORS":
            return {
                ...state,
                showErrors: action.payload as boolean,
            }
        case "SET_SHOW_EMAIL_ERRORS":
            return {
                ...state,
                showEmailError: action.payload as boolean,
            }
        case "SET_NAME_ERROR":
            return {
                ...state,
                nameError: action.payload as string,
            }
        case "SET_EMAIL_ERROR":
            return {
                ...state,
                emailError: action.payload as string,
            }
        case "SET_PHONE_ERROR":
            return {
                ...state,
                phoneError: action.payload as string,
            }
        case "SET_OFFER_ACCEPTED":
            return {
                ...state,
                offerAccepted: action.payload as boolean,
            }
        case "SET_PERSONAL_DATA_ACCEPTED":
            return {
                ...state,
                personalDataAccepted: action.payload as boolean,
            }
        case "SET_EULA_ACCEPTED":
            return {
                ...state,
                eulaAccepted: action.payload as boolean,
            }
        case "SET_INFORMED_AGREEMENT":
            return {
                ...state,
                informedAgreement: action.payload as boolean,
            }
        case "SET_PAY_BY_CARD": {
            return {
                ...state,
                payByCard: action.payload as PaymentMethod,
            }
        }
        default:
            return {
                ...state,
            }
    }
}
